import React from "react"
import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router"

import { Button, Stack, Typography, useTheme } from "@mui/material"

export const Page404: FC = () => {
  const { t } = useTranslation("common")
  const theme = useTheme()

  return (
    <Stack
      sx={{
        alignItems: "center",
        gap: 1,
        justifyContent: "center",
        bottom: 0,
        left: 0,
        position: "absolute",
        right: 0,
        textAlign: "center",
        top: 0,
      }}
    >
      <Typography
        sx={{
          color: "grey.200",
          fontSize: theme.typography.pxToRem(64),
          fontWeight: "bold",
          lineHeight: "normal",
        }}
      >
        {t("page404.title")}
      </Typography>
      <Typography variant="h1">{t("page404.message")}</Typography>
      <Typography
        sx={{
          fontWeight: "bold",
        }}
      >
        <Button component={RouterLink} to="/" variant="contained">
          {t("page404.returnHome")}
        </Button>
      </Typography>
    </Stack>
  )
}
